import React from 'react';
import { Link } from 'react-router';
import { AvatarWithFlag } from 'components/AvatarWithFlag/AvatarWithFlag';
import './AuthorByline.css';

interface AuthorBylineProps {
  author: {
    id: number;
    username: string;
    avatarUrl: string | null;
  };
  publishedDate?: string;
}

const formatBylineDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

const AuthorByline: React.FC<AuthorBylineProps> = ({ author, publishedDate }) => {
  return (
    <div className="author-byline">
      <AvatarWithFlag
        avatarUrl={author.avatarUrl}
        username={author.username}
        size={64}
      />
      <div className="author-byline-text">
        <span className="author-byline-label">
          published {publishedDate ? `${formatBylineDate(publishedDate)} ` : ''}by:
        </span>
        <Link to={`/profile/u/${encodeURIComponent(author.username)}`} className="author-byline-link">
          <span className="author-byline-name">{author.username}</span>
        </Link>
      </div>
    </div>
  );
};

export default AuthorByline;
